import { cva, type VariantProps } from 'class-variance-authority';
import type { MenuSize } from './menu-size-context';

/**
 * Row styling for every menu item type, in both menus. States are keyed on both
 * pseudo-classes and Base UI data attributes so a plain button reusing this cva
 * looks the same.
 */
export const menuItemVariants = cva(
  [
    'relative flex w-full cursor-default items-center rounded-lg text-text-primary outline-none select-none',
    'hover:bg-surface-hover focus-visible:bg-surface-hover data-highlighted:bg-surface-hover',
    'active:bg-surface-pressed focus-visible:active:bg-surface-pressed data-checked:active:bg-surface-pressed data-highlighted:active:bg-surface-pressed',
    // no semantic token for a hovered, highlighted or focused selected row, so the primitive one step up from Surface/Active
    'data-checked:bg-surface-active data-checked:hover:bg-indigo-crush-20 data-checked:focus-visible:bg-indigo-crush-20 data-highlighted:data-checked:bg-indigo-crush-20',
    'disabled:pointer-events-none disabled:text-text-disabled',
    'data-disabled:pointer-events-none data-disabled:text-text-disabled',
  ],
  {
    variants: {
      size: {
        sm: 'h-8 gap-2 px-3 typo-sm-semibold',
        standard: 'h-12 gap-2 px-4 typo-base-semibold',
      },
      variant: {
        default: '',
        destructive: 'text-feedback-error-accent',
      },
    },
    defaultVariants: {
      size: 'sm',
      variant: 'default',
    },
  },
);

export type MenuItemVariantsProps = VariantProps<typeof menuItemVariants>;

export const MENU_ICON_SIZE: Record<MenuSize, number> = { sm: 16, standard: 24 };

export const menuHeadingVariants = cva('text-text-secondary', {
  variants: {
    size: {
      sm: 'px-3 py-2.5 typo-xs-semibold',
      standard: 'px-4 py-3.5 typo-sm-semibold',
    },
  },
});

export const menuDividerVariants = cva('h-px bg-border-default', {
  variants: {
    size: {
      sm: 'my-1',
      standard: 'my-2',
    },
  },
});
